// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-benefits-iframe {
  height: 3900px;
  width: 100%;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/MemberBenefits/index.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;EACA,WAAA;EACA,SAAA;AAAF","sourcesContent":[".member-benefits-iframe {\n  // currently hardcoded height, no good way of styling based on iFrame element height due to CORS\n  height: 3900px;\n  width: 100%;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
